import { render, staticRenderFns } from "./TutorRecommendationCard.vue?vue&type=template&id=26278a60&scoped=true"
import script from "./TutorRecommendationCard.vue?vue&type=script&lang=js"
export * from "./TutorRecommendationCard.vue?vue&type=script&lang=js"
import style0 from "./TutorRecommendationCard.vue?vue&type=style&index=0&id=26278a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26278a60",
  null
  
)

export default component.exports